import { useTranslation } from 'react-i18next';
import { spacing } from '@tq/ui-components/dist/components/mobile-options-accordion/styles/theme/spacing';

import { UseConsultationStatusReturn } from './fragments/useConsultationStatusReturn';
import { tqConsultationStatusesConfig } from './fragments/tqConsultationStatuses.config';
import { niConsultationStatusesConfig } from './fragments/niConsultationStatuses.config';

export const STANDARD_WIDTH = spacing(24.5);

export const useConsultationStatuses = (isTQ: boolean): UseConsultationStatusReturn => {
  const { t } = useTranslation('consultation_status');
  return isTQ ? tqConsultationStatusesConfig(t) : niConsultationStatusesConfig(t);
};
